import React, {useState, KeyboardEvent} from 'react';
import {Input, Flex, Button} from '@priority-software/priority-style-react';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {ADD_LINK_COMMAND} from '../../commands';
import keyCodes from '../../../../../../../constants/KeyCodes';
import {texts} from '../../texts';
import styles from './LinkDialog.module.scss';

type Props = {
    onClose: () => void;
    defaultUrl?: string;
    defaultText?: string;
    update: boolean;
};

export const LinkDialog = ({defaultUrl, defaultText, onClose, update = false}: Props) => {
    const [linkURL, setLinkURL] = useState(defaultUrl);
    const [linkText, setLinkText] = useState(defaultText);
    const [editor] = useLexicalComposerContext();

    const onSubmit = () => {
        editor.dispatchCommand(ADD_LINK_COMMAND, {
            text: linkText || linkURL,
            url: linkURL,
            update
        });
        onClose();
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.keyCode === keyCodes.ENTER) {
            e.preventDefault();
            e.stopPropagation();
            onSubmit();
        }
    };

    return (
        <div className={styles.component}>
            <Input
                autoFocus
                componentClasses={styles.input}
                placeholder={'URL'}
                value={linkURL}
                onKeyDown={handleKeyDown}
                onChange={e => {
                    setLinkURL(e.target.value);
                }}
            />

            <Input
                componentClasses={styles.input}
                placeholder={'Text'}
                value={linkText}
                onKeyDown={handleKeyDown}
                onChange={e => {
                    setLinkText(e.target.value);
                }}
            />

            <Flex justifyContent="flex-end">
                <Button disabled={!linkURL} size="small" skin="primary" onClick={onSubmit}>
                    {texts.ok_label}
                </Button>
            </Flex>
        </div>
    );
};
